import React, { useEffect, useState, useCallback } from 'react';
import useApp from 'hooks/useApp'
import { Select, Logo, Layer } from 'components'
import styles from '../index.module.css'
import { useLocation } from 'react-router-dom'
import Lib from 'library'
import { financeSavingDetailState_2 } from './states'
import { useRecoilState } from 'recoil'

const FinanceSavingDetailLayer_2 = () => {

	const App = useApp()
	const location = useLocation();

	const [layerControl, setLayerControl] = useRecoilState(financeSavingDetailState_2)

	// #TODO: 정액 적립식 작업 X

	// const seq = layerControl.seq;
	// const dclsMonth = layerControl.dclsMonth;
	// const finCoNo = layerControl.finCoNo;
	// const finPrdtCd = layerControl.finPrdtCd;
	// const svg = layerControl.svg;
	
	const fsiId = layerControl.fsiId; // 상품 id
	const maxRate2 = layerControl.maxRate2; // 우대금리
	const [svg, setSvg] = useState(null); // 기본 데이터 - 전체 데이터
	const [savingOpLst, setSavingOpLst] = useState(null); // 기본 데이터 - options(적립방법, 개월수에 따른 결과값)

	const [monthDt, setMonthDt] = useState(""); // 셀렉트 선택값 - 개월수
	const [rsrvType, setRsrvType] = useState(""); // 셀렉트 선택값 - 적립방식

	const [saveTrmLst, setSaveTrmLst] = useState(null); // 셀렉트 리스트 - 개월수
	const [rsrvLst, setRsrvLst] = useState(null); // 셀렉트 리스트 - 적립방식

	const [isoType, setIsoType] = useState(null); // 단리 유무
	const [intType, setIntType] = useState(null); // 복리 유무

	const [accordionOpen, setAccordionOpen] = useState(true);
	const openAccordion = () => setAccordionOpen(!accordionOpen);

	const [resultLst, setResultLst] = useState(null);

	const savingRate = (data) => {


		// 적립유형 셀렉트 셋팅 --> 단리/복리
		const rsrvOpLst = new Map(data.map(rsrv => [rsrv.intrRateTypeNm]))
		const _rsrvLst = [...rsrvOpLst].map(([nm]) => ({ "rsrv_type": nm, "rsrv_type_nm": nm }));
		// 적립유형 셀렉트 옵션값
		setRsrvLst(_rsrvLst);
		// 적립유형 셀렉트 초기 값 설정
		setRsrvType(_rsrvLst[0].rsrv_type);

		// setSavingOpLst(data);

		
		const islt = data.filter(islt => islt.intrRateTypeNm === "단리")
			.map(islt => ({
				"save_trm": islt.saveTrm,
				"iso_type": islt.intrRateTypeNm,
				"iso_rate": islt.intrRate,
				"iso_rate2": islt.intrRate2,
			}));

		const intrt = data.filter(intrt => intrt.intrRateTypeNm === "복리")
			.map(intrt => ({
				"save_trm": intrt.saveTrm,
				"int_type": intrt.intrRateTypeNm,
				"int_rate": intrt.intrRate,
				"int_rate2": intrt.intrRate2,
			}));


		// 옵션 적립개월 수 기준(saveTrm) 셀렉트 셋팅
		const depositOptions = new Map(data.map(deposit => [deposit.saveTrm]));
		const dpstOpDate = [...depositOptions].map((dpst, i) => Number(dpst[0])).sort((a, b) => a - b);

		const _islt = dpstOpDate.map((dpst, index) => {
			const _isltOption = islt.find(v => v.save_trm === String(dpst));
			return !_isltOption ? {} : _isltOption;
		})

		const _intrt = dpstOpDate.map((dpst, index) => {
			const _intrtOption = intrt.find(v => v.save_trm === String(dpst));
			return !_intrtOption ? {} : _intrtOption;
		})

		const _list = dpstOpDate.map((v, i) => Object.assign(_islt[i], _intrt[i]))
		// 우대금리 확인
		// 단리기준 우대금리 확인
		let _maxList = _list.filter(max => max.iso_rate2 === maxRate2) // 단리
		if(_maxList.length < 1){
			// 단리기준 우대금리 없는 경우 복리로 재확인
			_maxList = _list.filter(max => max.int_rate2 === maxRate2) // 복리
		}
		// 개월수 셀렉트 옵션값
		setSaveTrmLst(_list);
		// 초기값 셋팅
		setIsoType(_maxList[0].iso_type || null); // 단리 기준 값이 있는지
		setIntType(_maxList[0].int_type || null); // 복리 기준 값이 있는지
		setMonthDt(_maxList[0].save_trm); // 개월수 초기 선택값
	}


	// 원본
	// 예금 getSavingDetailOption
	const getSavingDetailOption = (fsiId) => {
		Lib.myGet(`/api/recomm/saving/v1/${fsiId}`, (data) => {
			// 사용사 선택 옵션값 설정, 개월/적립방법 셀렉트 옵션값
			savingRate(data.data.options);
			// api 통신한 개월/적립방법 전체 결과값 저장
			setSavingOpLst(data.data.options);
			// api 통신한 기초 데이터
			setSvg(data.data);
		});
	}
	// 
	useEffect(() => {
		layerControl.show && getSavingDetailOption(fsiId);
	}, [layerControl.show, fsiId])

	const onResultSeleted = useCallback((key, value, set) => set(value), [saveTrmLst, rsrvType]);

	useEffect(() => {
		// 개월수 + 적립방식 선택 시 노출되는 금리 데이터 값 적용
		const _selectedData = savingOpLst && savingOpLst.find(v => v.saveTrm === monthDt && v.intrRateTypeNm === rsrvType);
		setResultLst(_selectedData);
	}, [savingOpLst, monthDt, rsrvType]);

	// 원본
	// 예금 getSavingDetailOption
	// // const getSavingDetailOption = (month, codeNo, prdtCode) => {
	// // 	Lib.post(`/api/finance/savingOption?dclsMonth=${month}&finCoNo=${codeNo}&finPrdtCd=${prdtCode}`, (data) => {
	// // 		setSavingOpLst(data);
	// // 		savingRate(data);
	// // 	});
	// // }
	// 상세보기시 기간, 금리가 안 보이는 오류가 있어서 매번 조회하도록 수정(layerControl.show 속성추가. 20221020)
	// useEffect(() => {
	// 	layerControl.show && getSavingDetailOption(dclsMonth, finCoNo, finPrdtCd);
	// }, [layerControl.show, dclsMonth, finCoNo, finPrdtCd])

	// const onResultSeleted = useCallback((key, value, set) => set(value), [saveTrmLst, rsrvType]);

	// useEffect(() => {
	// 	const _selectedData = savingOpLst && savingOpLst.find(v => v.save_trm === monthDt && v.rsrv_type === rsrvType);
	// 	setResultLst(_selectedData);
	// }, [savingOpLst, monthDt, rsrvType]);

	if (!svg) return null;

	return (
		<Layer show={layerControl.show} closeLayer={() => setLayerControl(prev => ({ ...prev, show: false }))}>
			<div className="page">
				<div className="shadow">
					<div className="padding">
						<div className="flex-justify_between align_center mt_10">
							<div className={styles["detail-title"]}>
								<span>{svg.korCoNm}</span>
								<p className="mt_5">{svg.finPrdtNm}</p>
								<i className="tag tag-box tag-blue mt_10">적금</i>
							</div>
							{/* <div className="img-box img-symbol img-symbol-lg ml_10">
								<Logo code={svg.fin_co_no} style={{ 'width': '6rem', 'height': '6rem' }} />
							</div> */}
						</div>
						<ul className={`${styles["count-list"]} mt_20`}>
							{maxRate2 &&
								<li>
									<p>우대금리</p>
									<strong>{Number(maxRate2).toFixed(2)}%</strong>
								</li>
							}
							{/* {
								svg.maxLimit &&
								<li>
									<p>최고한도</p>
									<strong>{
										Lib.isNull(svg.maxLimit) || !svg.maxLimit || svg.maxLimit  === 'null'
										? "정보없음" 
										: `${Lib.addComma(Number(svg.maxLimit))}원`
										}</strong>
									<strong>{Lib.addComma(svg.maxLimit)}원</strong>
								</li>
							} */}
						</ul>
					</div>
				</div>
				<div className="shadow">
					<div className="padding">
						<div className={`${accordionOpen ? "active" : ""} accordion-title flex-justify_between align_center`} onClick={openAccordion}>
							<h3>내가 이 상품에 가입한다면?</h3>
							<i className="icon icon_accordion_arrow" />
						</div>
						<div className="accordion-content">
							<div className="flex-justify_center mt_40">
								<i className="icon icon_finance_saving" />
							</div>
							<div className={`${styles["question-area"]} mt_20`}>
								<div className={styles.sec}>{svg.finPrdtNm} 상품을</div>
								<div className={styles.sec}>
									<Select
										className="mr_10"
										title="저축기간"
										selected={monthDt}
										data={saveTrmLst && saveTrmLst.map((savingOp) => (
											{ key: `${savingOp.save_trm}개월`, value: `${savingOp.save_trm}` }
										))}
										onSelect={(key, value) => {
											setMonthDt(value);
										}}>
									</Select>
									<span className="mr_10">동안</span>

									{rsrvType &&
										<>
											<Select
												className="mr_10"
												title="적립유형명"
												selected={rsrvType}
												data={rsrvLst && rsrvLst.map(rsrv => (
													{ key: rsrv.rsrv_type_nm, value: rsrv.rsrv_type }
												))}
												onSelect={(key, value) => onResultSeleted(key, value, setRsrvType)}
											>
											</Select>
											(으)로
										</>
									}
									저축할 경우
								</div>
							</div>

							{saveTrmLst && (
								<div className={`${styles["answer-box"]} mt_20`}>
									{resultLst &&
										<>
											{isoType && (
												<p>
													<strong>단리</strong>로 <strong>{parseFloat(resultLst.intrRate).toFixed(2)}%</strong> 저축금리를 받아요.<br />
													우대금리는 <strong>최고 {parseFloat(resultLst.intrRate2).toFixed(2)}%</strong> 받을 수 있네요!
												</p>
											)}
											{intType && (
												<p><strong>복리</strong>로 <strong>{parseFloat(resultLst.intrRate).toFixed(2)}%</strong> 저축금리를 받아요.<br />
													우대금리는 <strong>최고 {parseFloat(resultLst.intrRate2).toFixed(2)}%</strong> 받을 수 있네요!</p>
											)}
										</>
									}
									{/* <strong>단리</strong>로 <strong>{lmRate}%</strong> 저축금리를 받아요.<br />
										우대금리는 <strong>최고 {mxRate}%</strong> 받을 수 있네요! */}
								</div>
							)}
						</div>
					</div>
				</div>
				<div className="padding">
					<ul className="list-item list-item-left" style={{ fontSize: "1.2rem" }}>
					    {
                            ( svg.joinMember != null && svg.joinMember != "-" ) &&
                            <li>
                                <span>가입대상</span>
                                <span>{svg.joinMember}</span>
                            </li>
						}
						{
                            ( svg.joinDeny != null && svg.joinDeny != "-" ) &&
                            <li>
                                <span>가입제한</span>
                                <span>{svg.joinDeny}</span>
                            </li>
						}
						{
                            ( svg.joinWay != null && svg.joinWay != "-" ) &&
                            <li>
                                <span>가입방법</span>
                                <span>{svg.joinWay}</span>
                            </li>
						}
						{
                            ( svg.mtrtInt != null && svg.mtrtInt != "-" ) &&
                            <li>
                                <span>만기 후 이자율</span>
                                <span>만기 후<br />
                                    <div style={{ whiteSpace: "pre-wrap" }}>
                                        {svg.mtrtInt}
                                    </div>
                                </span>
                            </li>
						}
						{
                            ( svg.spclCnd != null && svg.spclCnd != "-" ) &&
                            <li>
                                <span>우대조건</span>
                                <span style={{ whiteSpace: "pre-wrap" }}>{svg.spclCnd}</span>
                            </li>
						}
						{
                            ( svg.etcNote != null && svg.etcNote != "-" ) &&
                            <li>
                                <span>기타 유의사항</span>
                                <span style={{ whiteSpace: "pre-wrap" }}>{svg.etcNote}</span>
                            </li>
						}
						{
                            ( svg.dclsStrtDay != null || svg.dclsEndDay != null ) &&
                            <li>
                                <span>공시 기간</span>
                                <span>{svg.dclsStrtDay} ~ {svg.dclsEndDay}</span>
                            </li>
						}
					</ul>
					<div className={`${styles["list-guide"]} mt_50`}>금융감독원의 금융상품 API를 통해 제공하는 정보입니다.</div>
				</div>
			</div>
		</Layer>
	)
}

export default FinanceSavingDetailLayer_2